import { useEffect, useState } from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { MapView } from "@/components/MapView";
import api from "@/lib/api";

export default function MapPage() {
  const [items, setItems] = useState([]);
  const [sector, setSector] = useState("");

  useEffect(() => {
    api.get("/machinery", { params: sector ? { sector } : {} }).then((r) => setItems(r.data));
  }, [sector]);

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8">
          <div>
            <div className="overline text-brand mb-2">Geolocalización</div>
            <h1 className="font-display font-black text-5xl tracking-tighter">MAPA DE EQUIPOS</h1>
          </div>
          <select value={sector} onChange={(e) => setSector(e.target.value)} data-testid="map-sector-filter"
            className="h-11 px-3 bg-background border border-input text-sm">
            <option value="">Todos los sectores</option>
            <option value="mineria">Minería</option>
            <option value="construccion">Construcción</option>
          </select>
        </div>
        <MapView items={items} height="600px" />
        <p className="text-sm text-muted-foreground mt-4">{items.length} equipos geolocalizados. Haz clic en un marcador para ver el detalle.</p>
      </div>
      <Footer />
    </div>
  );
}
